import { Duration as LuxonDuration } from "luxon";
import { Duration as ProtobufDuration } from "protos/google/protobuf/duration";

/**
 * Converts a Protobuf Duration object to a Luxon Duration object, which is
 * easier to handle with other JS date/time types.
 * @param pd a Protobuf Duration object
 * @returns a Luxon Duration object
 */
export function protobufDurationToLuxon(pd: ProtobufDuration): LuxonDuration {
  return LuxonDuration.fromObject({
    seconds: pd.seconds,
    milliseconds: pd.nanos / 1e6,
  });
}

/**
 * Converts a Luxon Duration object to a Protobuf Duration object which can be
 * serialized and sent to our backend services.
 * @param ld a Luxon Duration object
 * @returns a Protobuf Duration object
 */
export function luxonDurationToProtobuf(ld: LuxonDuration): ProtobufDuration {
  // shift internal representation of duration to seconds + milliseconds, for
  // further conversion to nanoseconds
  const temp = ld.shiftTo("seconds", "milliseconds");

  return {
    seconds: temp.seconds,
    nanos: temp.milliseconds * 1e6,
  };
}
